import type { VAxios } from '../../define/axios/Axios';

/**
 * pose 相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 通过上传图片解析骨骼图节点信息
  getPoseInfo: (params) => defHttp.post({ url: `/editor/pose`, params }),
});
